/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Ripia API
 * 美容サロン・リラクゼーション業界向け統合管理SaaSシステムAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkCreateCustomersDto,
  CreateCustomerDto,
  CustomerListResponseDto,
  CustomerResponseDto,
  CustomersControllerCheckDuplicate200,
  CustomersControllerCheckDuplicateParams,
  CustomersControllerFindAllParams,
  CustomersControllerFindDuplicatesParams,
  CustomersControllerPreviewMergeParams,
  MergeCustomersDto,
  UpdateCustomerDto
} from '../../schemas';

import { customInstance } from '../../../lib/custom-instance';




/**
 * @summary 新規顧客登録
 */
export const customersControllerCreate = (
    createCustomerDto: CreateCustomerDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerResponseDto>(
      {url: `/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomerDto, signal
    },
      );
    }
  


export const getCustomersControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerCreate>>, TError,{data: CreateCustomerDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof customersControllerCreate>>, TError,{data: CreateCustomerDto}, TContext> => {

const mutationKey = ['customersControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customersControllerCreate>>, {data: CreateCustomerDto}> = (props) => {
          const {data} = props ?? {};

          return  customersControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomersControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof customersControllerCreate>>>
    export type CustomersControllerCreateMutationBody = CreateCustomerDto
    export type CustomersControllerCreateMutationError = void

    /**
 * @summary 新規顧客登録
 */
export const useCustomersControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerCreate>>, TError,{data: CreateCustomerDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customersControllerCreate>>,
        TError,
        {data: CreateCustomerDto},
        TContext
      > => {

      const mutationOptions = getCustomersControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 顧客一覧取得
 */
export const customersControllerFindAll = (
    params?: CustomersControllerFindAllParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerListResponseDto>(
      {url: `/customers`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getCustomersControllerFindAllQueryKey = (params?: CustomersControllerFindAllParams,) => {
    return [
    `/customers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCustomersControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof customersControllerFindAll>>, TError = unknown>(params?: CustomersControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomersControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customersControllerFindAll>>> = ({ signal }) => customersControllerFindAll(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomersControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof customersControllerFindAll>>>
export type CustomersControllerFindAllQueryError = unknown


export function useCustomersControllerFindAll<TData = Awaited<ReturnType<typeof customersControllerFindAll>>, TError = unknown>(
 params: undefined |  CustomersControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindAll<TData = Awaited<ReturnType<typeof customersControllerFindAll>>, TError = unknown>(
 params?: CustomersControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindAll<TData = Awaited<ReturnType<typeof customersControllerFindAll>>, TError = unknown>(
 params?: CustomersControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客一覧取得
 */

export function useCustomersControllerFindAll<TData = Awaited<ReturnType<typeof customersControllerFindAll>>, TError = unknown>(
 params?: CustomersControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomersControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客一括登録（CSVインポート）
 */
export const customersControllerBulkCreate = (
    bulkCreateCustomersDto: BulkCreateCustomersDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/customers/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkCreateCustomersDto, signal
    },
      );
    }
  


export const getCustomersControllerBulkCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerBulkCreate>>, TError,{data: BulkCreateCustomersDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof customersControllerBulkCreate>>, TError,{data: BulkCreateCustomersDto}, TContext> => {

const mutationKey = ['customersControllerBulkCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customersControllerBulkCreate>>, {data: BulkCreateCustomersDto}> = (props) => {
          const {data} = props ?? {};

          return  customersControllerBulkCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomersControllerBulkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof customersControllerBulkCreate>>>
    export type CustomersControllerBulkCreateMutationBody = BulkCreateCustomersDto
    export type CustomersControllerBulkCreateMutationError = unknown

    /**
 * @summary 顧客一括登録（CSVインポート）
 */
export const useCustomersControllerBulkCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerBulkCreate>>, TError,{data: BulkCreateCustomersDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customersControllerBulkCreate>>,
        TError,
        {data: BulkCreateCustomersDto},
        TContext
      > => {

      const mutationOptions = getCustomersControllerBulkCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 顧客重複チェック（メール・電話番号）
 */
export const customersControllerCheckDuplicate = (
    params?: CustomersControllerCheckDuplicateParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CustomersControllerCheckDuplicate200>(
      {url: `/customers/check-duplicate`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getCustomersControllerCheckDuplicateQueryKey = (params?: CustomersControllerCheckDuplicateParams,) => {
    return [
    `/customers/check-duplicate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCustomersControllerCheckDuplicateQueryOptions = <TData = Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError = unknown>(params?: CustomersControllerCheckDuplicateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomersControllerCheckDuplicateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>> = ({ signal }) => customersControllerCheckDuplicate(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomersControllerCheckDuplicateQueryResult = NonNullable<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>>
export type CustomersControllerCheckDuplicateQueryError = unknown


export function useCustomersControllerCheckDuplicate<TData = Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError = unknown>(
 params: undefined |  CustomersControllerCheckDuplicateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerCheckDuplicate>>,
          TError,
          Awaited<ReturnType<typeof customersControllerCheckDuplicate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerCheckDuplicate<TData = Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError = unknown>(
 params?: CustomersControllerCheckDuplicateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerCheckDuplicate>>,
          TError,
          Awaited<ReturnType<typeof customersControllerCheckDuplicate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerCheckDuplicate<TData = Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError = unknown>(
 params?: CustomersControllerCheckDuplicateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客重複チェック（メール・電話番号）
 */

export function useCustomersControllerCheckDuplicate<TData = Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError = unknown>(
 params?: CustomersControllerCheckDuplicateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerCheckDuplicate>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomersControllerCheckDuplicateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 重複疑いのある顧客候補一覧
 */
export const customersControllerFindDuplicates = (
    params?: CustomersControllerFindDuplicatesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/customers/duplicates`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getCustomersControllerFindDuplicatesQueryKey = (params?: CustomersControllerFindDuplicatesParams,) => {
    return [
    `/customers/duplicates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCustomersControllerFindDuplicatesQueryOptions = <TData = Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError = unknown>(params?: CustomersControllerFindDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomersControllerFindDuplicatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customersControllerFindDuplicates>>> = ({ signal }) => customersControllerFindDuplicates(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomersControllerFindDuplicatesQueryResult = NonNullable<Awaited<ReturnType<typeof customersControllerFindDuplicates>>>
export type CustomersControllerFindDuplicatesQueryError = unknown


export function useCustomersControllerFindDuplicates<TData = Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError = unknown>(
 params: undefined |  CustomersControllerFindDuplicatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindDuplicates>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindDuplicates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindDuplicates<TData = Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError = unknown>(
 params?: CustomersControllerFindDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindDuplicates>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindDuplicates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindDuplicates<TData = Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError = unknown>(
 params?: CustomersControllerFindDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 重複疑いのある顧客候補一覧
 */

export function useCustomersControllerFindDuplicates<TData = Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError = unknown>(
 params?: CustomersControllerFindDuplicatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindDuplicates>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomersControllerFindDuplicatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客マージプレビュー
 */
export const customersControllerPreviewMerge = (
    params: CustomersControllerPreviewMergeParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/customers/merge/preview`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getCustomersControllerPreviewMergeQueryKey = (params?: CustomersControllerPreviewMergeParams,) => {
    return [
    `/customers/merge/preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCustomersControllerPreviewMergeQueryOptions = <TData = Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError = void>(params: CustomersControllerPreviewMergeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomersControllerPreviewMergeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customersControllerPreviewMerge>>> = ({ signal }) => customersControllerPreviewMerge(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomersControllerPreviewMergeQueryResult = NonNullable<Awaited<ReturnType<typeof customersControllerPreviewMerge>>>
export type CustomersControllerPreviewMergeQueryError = void


export function useCustomersControllerPreviewMerge<TData = Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError = void>(
 params: CustomersControllerPreviewMergeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerPreviewMerge>>,
          TError,
          Awaited<ReturnType<typeof customersControllerPreviewMerge>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerPreviewMerge<TData = Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError = void>(
 params: CustomersControllerPreviewMergeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerPreviewMerge>>,
          TError,
          Awaited<ReturnType<typeof customersControllerPreviewMerge>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerPreviewMerge<TData = Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError = void>(
 params: CustomersControllerPreviewMergeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客マージプレビュー
 */

export function useCustomersControllerPreviewMerge<TData = Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError = void>(
 params: CustomersControllerPreviewMergeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerPreviewMerge>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomersControllerPreviewMergeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客マージ実行
 */
export const customersControllerMergeCustomers = (
    mergeCustomersDto: MergeCustomersDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/customers/merge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mergeCustomersDto, signal
    },
      );
    }
  


export const getCustomersControllerMergeCustomersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerMergeCustomers>>, TError,{data: MergeCustomersDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof customersControllerMergeCustomers>>, TError,{data: MergeCustomersDto}, TContext> => {

const mutationKey = ['customersControllerMergeCustomers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customersControllerMergeCustomers>>, {data: MergeCustomersDto}> = (props) => {
          const {data} = props ?? {};

          return  customersControllerMergeCustomers(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomersControllerMergeCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof customersControllerMergeCustomers>>>
    export type CustomersControllerMergeCustomersMutationBody = MergeCustomersDto
    export type CustomersControllerMergeCustomersMutationError = void

    /**
 * @summary 顧客マージ実行
 */
export const useCustomersControllerMergeCustomers = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerMergeCustomers>>, TError,{data: MergeCustomersDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customersControllerMergeCustomers>>,
        TError,
        {data: MergeCustomersDto},
        TContext
      > => {

      const mutationOptions = getCustomersControllerMergeCustomersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 顧客コードで検索
 */
export const customersControllerFindByCustomerCode = (
    customerCode: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/customers/code/${customerCode}`, method: 'GET', signal
    },
      );
    }
  



export const getCustomersControllerFindByCustomerCodeQueryKey = (customerCode?: string,) => {
    return [
    `/customers/code/${customerCode}`
    ] as const;
    }

    
export const getCustomersControllerFindByCustomerCodeQueryOptions = <TData = Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError = void>(customerCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomersControllerFindByCustomerCodeQueryKey(customerCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>> = ({ signal }) => customersControllerFindByCustomerCode(customerCode, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomersControllerFindByCustomerCodeQueryResult = NonNullable<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>>
export type CustomersControllerFindByCustomerCodeQueryError = void


export function useCustomersControllerFindByCustomerCode<TData = Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError = void>(
 customerCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindByCustomerCode<TData = Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError = void>(
 customerCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindByCustomerCode<TData = Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError = void>(
 customerCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客コードで検索
 */

export function useCustomersControllerFindByCustomerCode<TData = Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError = void>(
 customerCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindByCustomerCode>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomersControllerFindByCustomerCodeQueryOptions(customerCode,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客詳細取得
 */
export const customersControllerFindOne = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerResponseDto>(
      {url: `/customers/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getCustomersControllerFindOneQueryKey = (id?: string,) => {
    return [
    `/customers/${id}`
    ] as const;
    }

    
export const getCustomersControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof customersControllerFindOne>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomersControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customersControllerFindOne>>> = ({ signal }) => customersControllerFindOne(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomersControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof customersControllerFindOne>>>
export type CustomersControllerFindOneQueryError = void


export function useCustomersControllerFindOne<TData = Awaited<ReturnType<typeof customersControllerFindOne>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindOne<TData = Awaited<ReturnType<typeof customersControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customersControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof customersControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomersControllerFindOne<TData = Awaited<ReturnType<typeof customersControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 顧客詳細取得
 */

export function useCustomersControllerFindOne<TData = Awaited<ReturnType<typeof customersControllerFindOne>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customersControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomersControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 顧客情報更新
 */
export const customersControllerUpdate = (
    id: string,
    updateCustomerDto: UpdateCustomerDto,
 ) => {
      
      
      return customInstance<CustomerResponseDto>(
      {url: `/customers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomerDto
    },
      );
    }
  


export const getCustomersControllerUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerUpdate>>, TError,{id: string;data: UpdateCustomerDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof customersControllerUpdate>>, TError,{id: string;data: UpdateCustomerDto}, TContext> => {

const mutationKey = ['customersControllerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customersControllerUpdate>>, {id: string;data: UpdateCustomerDto}> = (props) => {
          const {id,data} = props ?? {};

          return  customersControllerUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomersControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof customersControllerUpdate>>>
    export type CustomersControllerUpdateMutationBody = UpdateCustomerDto
    export type CustomersControllerUpdateMutationError = void

    /**
 * @summary 顧客情報更新
 */
export const useCustomersControllerUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerUpdate>>, TError,{id: string;data: UpdateCustomerDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customersControllerUpdate>>,
        TError,
        {id: string;data: UpdateCustomerDto},
        TContext
      > => {

      const mutationOptions = getCustomersControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary 顧客削除
 */
export const customersControllerRemove = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/customers/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getCustomersControllerRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerRemove>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof customersControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['customersControllerRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customersControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  customersControllerRemove(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomersControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof customersControllerRemove>>>
    
    export type CustomersControllerRemoveMutationError = void

    /**
 * @summary 顧客削除
 */
export const useCustomersControllerRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customersControllerRemove>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customersControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCustomersControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    